<kui-alert type="danger"
    class="key-alert-wrapper"
    *ngIf="errorMessage">
    <kui-icon name="ban"
        size="sm"></kui-icon>
    <span>{{errorMessage}}</span>
</kui-alert>

<key-layout-grid-columns direction="horizontal"
    class="page-body">
<key-layout-grid-column *ngIf="isAdvanced || isMobile"
    [size]="getListSize()"
        (onResized)="updateListWidth($event)"
        [resizable]="!isMobile"
        minSize="300"
        [class.hidden]="isMobile && selectedAsset">

        <key-overview-list key-layout-grid-column-inner
            class="list-view w-100 page-card"
            [show]="!(isMobile && selectedAsset)"
            [assets]="assetsList"
            [activeAssetId]="selectedAsset?.id"
            [listLoaded]="assetListLoaded"
            [layout]="state.listLayoutType"
            [count]="assetState.count"
            [title]="isMobile ? clientName : ('STATUS.OVERVIEW.ASSETS' | translate )"
            [dateHighlightThreshold]="state.dateHighlightThreshold"
            [dateFormatting]="state.dateFormatting"
            [filter]="state.filter"
            [sortField]="state.listSortField"
            [sortOrder]="state.listSortOrder"
            [stateProfiles]="stateProfiles"
            [errorMessage]="errorMessage"
            [page]="page"
            [filterWidth]="filterWidth"
            (mobileAction)="mobileActions.toggleSidebar()"
            (searchTermChanged)="changeSearchTerm($event)"
            (activeItemSelected)="setSelectedAsset($event)"
            (layoutChanged)="changeListLayout($event)"
            (dateHighlightThresholdChanged)="updateDateHighlightThreshold($event)"
            (dateFormattingChanged)="updateDateFormatting($event)"
            (filterChanged)="filterChanged($event)"
            (filtersToggled)="toggleFilterPanel($event)"
            (pageChanged)="updatePage($event)"
            (sortingChanged)="updateListSorting($event)"></key-overview-list>
    </key-layout-grid-column>

    <key-layout-grid-column *ngIf="isAdvanced || isMobile"
        class="h-100"
        [class.hidden]="isMobile && !selectedAsset">

        <!-- For mobile, bottom and right layouts --->
        <key-layout-grid-columns *ngIf="isMobile || state.detailsLocation === 'bottom' || state.detailsLocation === 'right'"
            [direction]="state.detailsLocation === 'bottom' ? 'vertical' : 'horizontal'"
            class="h-100">

            <!-- MAP -->
            <key-layout-grid-column class="h-100"
                [size]="selectedAsset ? state.mapHeight + 'px' : '100%'"
                (onResized)="updateMapHeight($event)"
                [resizable]="selectedAsset && !isMobile"
                [direction]="state.detailsLocation === 'bottom' ? 'vertical' : 'horizontal'"
                *ngIf="!isMobile">
                <key-overview-map class="page-card"
                    key-layout-grid-column-inner
                    [isMobile]="isMobile"
                    [assets]="assetsList"></key-overview-map>
            </key-layout-grid-column>

            <!-- DETAILS go here -->
            <router-outlet></router-outlet>

        </key-layout-grid-columns>

        <!-- For left layout --->
        <key-layout-grid-columns *ngIf="!isMobile && state.detailsLocation === 'left'"
            direction="horizontal"
            class="h-100">

            <key-layout-grid-column class="h-100"
                [size]="selectedAsset ? state.mapHeight + 'px' : '0'"
                (onResized)="updateMapHeight($event)"
                [resizable]="selectedAsset"
                direction="horizontal">

                <router-outlet></router-outlet>

            </key-layout-grid-column>

            <key-overview-map class="page-card"
                key-layout-grid-column-inner
                [isMobile]="isMobile"
                [assets]="assetsList"></key-overview-map>

        </key-layout-grid-columns>
    </key-layout-grid-column>

    <!-- BASIC LAYOUT -->
    <key-layout-grid-column *ngIf="!isAdvanced && !isMobile"
        class="h-100 basic-layout">

        <key-overview-map class="page-card"
            key-layout-grid-column-inner
            [isMobile]="isMobile"
            [assets]="assetsList"
            [buttons]="mapButtons"
            (onButtonClicked)="toggleSideBar(true)">
        </key-overview-map>

        <kui-side-panel [absolute]="true"
            [class.hidden]="!(sidebarOpen || selectedAsset)"
            align="left"
            [width]="sidebarWidth">

            <div class="h-100"
                [class.hidden]="selectedAsset">
                <key-overview-list key-layout-grid-column-inner
                    class="list-view w-100 page-card"
                    show="true"
                    closable="true"
                    [assets]="assetsList"
                    [activeAssetId]="selectedAsset?.id"
                    [listLoaded]="assetListLoaded"
                    layout="list"
                    [count]="assetState.count"
                    [title]="isMobile ? clientName : ('STATUS.OVERVIEW.ASSETS' | translate )"
                    [dateHighlightThreshold]="state.dateHighlightThreshold"
                    [dateFormatting]="state.dateFormatting"
                    [filter]="state.filter"
                    [sortField]="state.listSortField"
                    [sortOrder]="state.listSortOrder"
                    [stateProfiles]="stateProfiles"
                    [errorMessage]="errorMessage"
                    [page]="page"
                    [filterWidth]="filterWidth"
                    (mobileAction)="mobileActions.toggleSidebar()"
                    (searchTermChanged)="changeSearchTerm($event)"
                    (activeItemSelected)="setSelectedAsset($event)"
                    (layoutChanged)="changeListLayout($event)"
                    (dateHighlightThresholdChanged)="updateDateHighlightThreshold($event)"
                    (dateFormattingChanged)="updateDateFormatting($event)"
                    (filterChanged)="filterChanged($event)"
                    (filtersToggled)="toggleFilterPanel($event)"
                    (pageChanged)="updatePage($event)"
                    (sortingChanged)="updateListSorting($event)"
                    (onClose)="toggleSideBar(false)"></key-overview-list>
            </div>

            <div class="h-100"
                [class.hidden]="!selectedAsset">
                <!-- DETAILS go here -->
                <router-outlet></router-outlet>
            </div>

        </kui-side-panel>
    </key-layout-grid-column>


</key-layout-grid-columns>